import React, { useState, useEffect } from 'react'
import { Alert, Button, ButtonGroup, Card, Col, Form, Row, Modal, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import CustomNavbar from '../../components/CustomNavbar';
//import SidebarDashboard from '../../components/SidebarDashboard';
import CustomTable from '../../components/CustomTable';
import CustomPagination from '../../components/CustomPagination';
import { getJobs, saveJob, editJob, deleteJob } from '../../redux/jobs/actions';
import { getJobPositions } from '../../redux/jobposition/actions';

import messages from '../../redux/messages';
import SidebarConfig from '../../components/SidebarConfig';
const Jobs = props => {
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState('');
  //const [loadingType, setLoadingType] = useState('initial');
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();

  const data = useSelector(store => store.jobs.jobs);
  const positions = useSelector(store => store.jobPositions.jobPositions);
  const dataLenght = useSelector(store => store.jobs.jobsLength);
  const pages = Math.ceil(dataLenght / limit);
  const loading = useSelector(store => store.jobs.loading);
  const saveLoading = useSelector(store => store.jobs.saveLoadig);
  const loadingPosit = useSelector(store => store.jobPositions.loading);

  const columns = [
    {
      Header: 'Serie',
      accessor: 'serie'
    },
    {
      Header: 'Descripción',
      accessor: 'descripcion'
    },
    {
      Header: 'Posición',
      accessor: 'puesto'
    },
    {
      id: 'customButtons',
      Filter: '',
      Cell: value => (<div 
        className="btn-group" 
        role="group">
        <Button
          size="sm"
          variant="link"
          type="button"
          onClick={() => onEdit(value.row.original, value.row.index)}>
            <i className="material-icons">edit</i>
        </Button>
        <Button
          size="sm"
          className="text-danger"
          variant="link"
          type="button"
          onClick={() => onDelete(value.row.original.id, value.row.index)}>
          <i className="material-icons">close</i>
        </Button>
      </div>)
    }
  ];

  // Métodos
  useEffect(() => {
    dispatch(getJobs({
      offset: offset,
      limit: limit,
      filter: filter
    }, parseInt(props.match.params.type)));
    dispatch(getJobPositions({}, parseInt(props.match.params.type)));
  }, [dispatch, offset, limit, filter, props.match.params.type]);

  const addJobPosition = () => {
    setShowModal(true);
    setEdit(false);
    //setLoadingType('modal');
    setValidated(false);
  }

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    //setLoadingType('modal');
    setValidated(false);
  }

  /*Paginación*/
  const prev = () => {
    if(currentPage <= 0)
      setCurrentPage(0);
    else
      setCurrentPage(currentPage - 1);

    setOffset(offset - limit);
  }

  const next = () => {
    if (currentPage >= pages)
      setCurrentPage(pages);
    else
      setCurrentPage(currentPage + 1);
    
    setOffset(offset + limit);
  }

  const last = () => {
    setCurrentPage(pages);
    setOffset((pages * limit) - limit);
  }

  const first = () => {
    setCurrentPage(1);
    setOffset(0);
  }

  const onChangeLimit = value => {
    setLimit(parseInt(value));
    setOffset(0);
    setCurrentPage(1);
  };
  /*fin paginación*/

  const onSearch = e => {
    e.preventDefault();
    if (!e.target.filter.value.trim()) {
      return;
    }
    setFilter(e.target.filter.value);
    // if(!filter.trim()){
    //   return;
    // }
    //setLoadingType('initial');
    // dispatch(getJobs({
    //   offset: offset,
    //   limit: limit,
    //   filter: filter
    // }));
  }

  const onSubmitJobPosition = e => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }
    const req = {
      serie: e.target.serie.value,
      descripcion: e.target.name.value,
      puesto: (e.target.puesto.value)
    };

    if(!edit){
      dispatch(saveJob(req));
      e.target.reset();
      setShowModal(false);
    }else{
      dispatch(editJob(req, editItem.id, index));
      setShowModal(false);
    }
  }

  const seeAll = () => {
    dispatch(getJobs({
      offset: offset,
      limit: limit,
      filter: ''
    }));
  }

  const onDelete = (id, index) => {
    if(window.confirm(messages.preguntaEliminar)){
      dispatch(deleteJob(id, index));
    }
  }

// const onBlurValidateFormat = e => {
//   const value = e.target.serie.value;
//   const regex = /([a-zA-Z]{4})+-([0-9]{3})+([a-zA-Z]{2})+$/g;
//   if (!value.match(regex)) {
//     <Form.Control.Feedback type="invalid">
//       **Este campo solo admite números y letras
//     </Form.Control.Feedback>
//   }
// }

  const onShowSidebar = () => setShow(show ? false : true);
  return (
    <>
      <CustomNavbar type={'dashboard'} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container-fluid">
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="font-weight-bold text-uppercase">Función</h5>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                {/* <Col xs="auto">
                  <Form.Control
                  onChange={ e => setFilter(e.target.value)}
                  placeholder="Buscar"
                  className="rounded-pill form-control-sm"
                  type="search"></Form.Control>
                </Col> */}
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle">
                      <i className="material-icons">visibility</i>
                    </Button>
                    <Button 
                      variant="light" 
                      size="sm"
                      className="rounded-circle"
                      onClick={() => addJobPosition()}><i className="material-icons">add</i></Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {
            loading ? (
              <div className="d-flex justify-content-center">
                <Spinner 
                  animation="border" 
                  role="status" 
                  className="d-flex justify-content-center" />
              </div>
            ) : data.length > 0 ? (
              <> 
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable
                      columns={columns}
                      data={data} />
                  </Card.Body>
                </Card>
                <CustomPagination 
                  limit={limit}
                  offset={offset}
                  currentPage={currentPage}
                  dataLenght={dataLenght}
                  pages={pages}
                  prev={ prev }
                  next={ next }
                  first={ first }
                  last={ last }
                  onChangeLimit={onChangeLimit} />
              </>
            ) : (
              <Alert
                className="my-4" 
                variant="info">
                Aún no hay plazas, comienza agregando algunos
              </Alert>
            )
          }
        </div>
      </div>
      <Modal 
        show={showModal}
        onHide={() => setShowModal(false)}>
        <Form onSubmit={onSubmitJobPosition} noValidate validated={validated}>
          <Modal.Header closeButton>
            <Modal.Title>{edit ? 'Editar plaza' : 'Crear plaza'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group as={Row} className="mb-3">
              <Form.Label 
                column 
                sm="12"
                md="4">Serie</Form.Label>
              <Col 
                sm="12"
                md="8">
                <Form.Control
                  name="serie"
                  className="rounded-pill"
                  required
                  type="text"
                  defaultValue={ edit ? editItem.serie : null}
                  // onChange={()=> onBlurValidateFormat()}
                  pattern="[A-Za-z0-9]+"
                  placeholder="Serie"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  **Solo admite números y letras
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label 
                column 
                sm="12"
                md="4">Nombre de plaza</Form.Label>
              <Col 
                sm="12"
                md="8">
                <Form.Control
                  name="name"
                  className="rounded-pill"
                  required
                  type="text"
                  defaultValue={ edit ? editItem.descripcion : null}
                  pattern="[a-zA-Z][a-zA-Z\s]*"
                  placeholder="Nombre de puesto"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  **Solo admite letras
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Form.Label 
                column 
                sm="12"
                md="4">Posición</Form.Label>
              <Col 
                sm="12"
                md="8">
                <Row className="align-items-center">
                  <Col sm={ loadingPosit ? '10': '12' }>
                    <Form.Control
                      as="select"
                      name="puesto"
                      id="puesto"
                      className="rounded-pill"
                      required
                      defaultValue={ edit ? editItem.puesto : null }
                      placeholder="Puesto">
                        {
                          positions.map(item => (
                            <option key={item.id} value={item.id}>{item.descripcion}</option>
                          ))
                        }
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                  {
                    loadingPosit && (
                      <Col sm="2">
                        <Spinner animation="border" size="sm" />
                      </Col>
                    )
                  }
                </Row>
              </Col>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"  
              variant="secondary" 
              onClick={() => setShowModal(false)}>
              Cerrar
            </Button>
            <Button
              className="rounded-pill" 
              disabled={saveLoading}  
              variant="primary" 
              type="submit">
                {
                  saveLoading ? (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true" />
                  ): null
                }
                Guardar</Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  )
}

export default Jobs